import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";
import task04 from "./layouts/task-04/task";

const lesson: Lesson = {
  id: "ba809181-f0ac-43ad-9a02-2c03069c02b1",
  publicId: "23",
  name: "Acoustic classification of sound insulation",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, task01, task02, task03, task04],
};

export default lesson;
